/**
 * Enumeration for HTTP methods.
 *
 * @property {string} GET - The GET method requests a representation of the specified resource.
 * @property {string} POST - The POST method is used to submit data to be processed to a specified resource.
 */
export enum HttpMethod {
    GET = 'GET',
    POST = 'POST'
}
